import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../../modules/reports/jobs/siteWorkSchedulesReportActions'
import * as api from '../../../api/reports/jobs/siteWorkSchedulesReport'

function* siteWorkSchedulesReportGetJobList(action) {
  try {
    const payload = yield call(api.getJobList, action.filters)
    yield put({ type: constants.SITE_WORK_SCHEDULES_REPORT_GET_JOB_LIST.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.SITE_WORK_SCHEDULES_REPORT_GET_JOB_LIST.FAILED,
      message: e.message || e
    })
  }
}

function* siteWorkSchedulesReportGetFullReport(action) {
  try {
    const payload = yield call(api.getFullReport, action.filters)
    yield put({ type: constants.SITE_WORK_SCHEDULES_REPORT_GET_FULL_REPORT.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.SITE_WORK_SCHEDULES_REPORT_GET_FULL_REPORT.FAILED,
      message: e.message || e
    })
  }
}

/**
 * Saga
 */

function* watchsiteWorkSchedulesReportGetJobList() {
  yield takeLatest(
    constants.SITE_WORK_SCHEDULES_REPORT_GET_JOB_LIST.ACTION,
    siteWorkSchedulesReportGetJobList
  )
}

function* watchsiteWorkSchedulesReportGetFullReport() {
  yield takeLatest(
    constants.SITE_WORK_SCHEDULES_REPORT_GET_FULL_REPORT.ACTION,
    siteWorkSchedulesReportGetFullReport
  )
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchsiteWorkSchedulesReportGetJobList),
    fork(watchsiteWorkSchedulesReportGetFullReport)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/reports/jobs/siteWorkSchedulesReportSaga.js